import type { Currency } from '@ps/web-core-enums';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Translation from '@swf/components/Translation/Translation';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { EnvoyBankInfo } from '../../../../../../../../types/Cashier';
import { isZeroExponentCurrency, trimWithoutRounding } from '../../../../../../../../utils/cashier';
import BankInfo from '../BankInfo/BankInfo';

import {
  TXTWCL_Bank_transfers_can_take_severa_ELL,
  TXTWCL_Just_so_you_knowXX,
  TXTWCL_WeXve_sent_N0Xs_details_to_N1X,
  TXTWCL_XolXXliXHead_to_your_online_ba_ELL
} from './EnvoyLbt.messages.json';

interface Props {
  bankInfo?: EnvoyBankInfo;
  amount: number;
  currency: Currency;
  userEmail?: string;
}

const EnvoyLbt: React.FC<Props> = ({ bankInfo, amount, currency, userEmail }) => {
  const {
    data: { depositResult }
  } = useWizardContext();
  const { uniqueRefId } = depositResult || {};

  return (
    <>
      <Translation
        tagName="p"
        {...TXTWCL_WeXve_sent_N0Xs_details_to_N1X}
        values={{ 0: bankInfo?.name, 1: <b>{userEmail}</b> }}
      />
      <Translation
        {...TXTWCL_XolXXliXHead_to_your_online_ba_ELL}
        values={{
          0: (
            <b>
              <CurrencyAmount
                value={trimWithoutRounding(amount)}
                isZeroExponentCurrency={isZeroExponentCurrency(currency)}
                currency={currency}
                dollarValue
                currencyDisplay="code"
              />
            </b>
          ),
          1: ''
        }}
      />
      <BankInfo bankInfo={bankInfo} uniqueRefId={uniqueRefId} />
      <Translation tagName="b" {...TXTWCL_Just_so_you_knowXX} />
      <Translation tagName="div" {...TXTWCL_Bank_transfers_can_take_severa_ELL} />
    </>
  );
};

export default EnvoyLbt;
